import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { SearchSummaryButton } from '@vio/shared/src/search/SearchSummaryButton';
import { getSearchDisplayName } from 'modules/search/selectors';
import { getSearchBoxDestinationDisplayValue, getSearchBoxValues, getShowRoomsLabel } from 'modules/searchBox/selectors';
import { openSearchBox, setIsSearchBoxActive } from 'modules/searchBox/slice';
import { SearchBoxAncestor } from 'modules/searchBox/types';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { logTimeStart } from '@daedalus/core/src/_web/utils/logging/performanceTimer';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { roomsToConfigurationObject } from '@daedalus/core/src/room/business/roomConfiguration';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
interface PropsType {
  ancestor: SearchBoxAncestor;
  isCompact?: boolean;
  withSidePadding?: boolean;
  /** Whether the button is used in the new search bar */
  isNewSearchSummary?: boolean; // Added as part of 1c5ad789-mobile-top-bar
}
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wumj66q",
  propsAsIs: false
});
export const SearchSummaryButtonWithStore = ({
  ancestor,
  isCompact = false,
  withSidePadding = true,
  isNewSearchSummary = false // Added as part of 1c5ad789-mobile-top-bar
}: PropsType) => {
  const dispatch = useDispatch();
  const {
    rooms,
    checkIn,
    checkOut
  } = useSelector(getSearchBoxValues) || {};
  const searchDisplayName = useSelector(getSearchDisplayName);
  const searchBoxDestinationDisplayValue = useSelector(getSearchBoxDestinationDisplayValue);
  const destination = searchDisplayName || searchBoxDestinationDisplayValue;
  const showRoomsLabel = useSelector(getShowRoomsLabel);
  const {
    brandHasAlternativeSearchForm
  } = useBrand();
  const {
    numberOfAdults,
    numberOfChildren,
    numberOfRooms
  } = roomsToConfigurationObject(rooms);
  const checkOutDate = dateStringToMiddayDate(checkOut);
  const checkInDate = dateStringToMiddayDate(checkIn);
  const handleClick = useCallback(() => {
    logTimeStart('SearchBoxReady');
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.SearchSummary,
      action: Action.Clicked
    }));
    dispatch(openSearchBox(ancestor));
    dispatch(setIsSearchBoxActive(true));
  }, [dispatch, ancestor]);
  return <Wrapper className={withSidePadding && '__padding'}>
      <SearchSummaryButton checkIn={checkInDate} checkOut={checkOutDate} destination={destination} numberOfGuests={numberOfAdults + numberOfChildren} numberOfRooms={numberOfRooms} onClick={handleClick} isCompact={isCompact} isRoomsLabelShown={showRoomsLabel} isRounded={!brandHasAlternativeSearchForm} isNeutralColor={brandHasAlternativeSearchForm} isNewSearchSummary={isNewSearchSummary} />
    </Wrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");